import { render, staticRenderFns } from "./kpis.vue?vue&type=template&id=7f05962b&scoped=true&"
import script from "./kpis.vue?vue&type=script&lang=js&"
export * from "./kpis.vue?vue&type=script&lang=js&"
import style0 from "./kpis.vue?vue&type=style&index=0&id=7f05962b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f05962b",
  null
  
)

export default component.exports